import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

type ExpectedItem = {
  index: number;
  title: string;
  description: string | null;
  checked: boolean;
};

type Props = {
  items: ExpectedItem[];
  readOnly: boolean;
  onToggle: (index: number, checked: boolean) => void;
};

export function MilestoneExpectedList({ items, readOnly, onToggle }: Props) {
  if (items.length === 0) return null;
  return (
    <ul className="divide-y divide-border rounded-lg border bg-card">
      {items.map((item) => (
        <li key={item.index} className="flex items-start gap-3 p-4">
          <Checkbox
            checked={item.checked}
            disabled={readOnly}
            onCheckedChange={(value) => onToggle(item.index, value === true)}
            aria-label={item.title}
            className="mt-0.5"
          />
          <div className="flex-1 min-w-0">
            <div
              className={cn(
                "text-sm font-medium",
                item.checked && "line-through text-muted-foreground",
              )}
            >
              {item.title}
            </div>
            {item.description && (
              <div className="text-xs text-muted-foreground mt-1">{item.description}</div>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
